import React, { useContext } from 'react';
import ProductPageContext from '../../contexts/ProductPageContext';

export default function MemberEarlyAccessDescription({ isQuickView = false }) {
  const ProductPageState = useContext(ProductPageContext);

  const {
    tmntData,
  } = ProductPageState;

  return (
    <div className={`member-early-access-description ${isQuickView ? 'quickview' : ''}`} data-testid="member-early-access-description">
      { isQuickView ? `${tmntData.earlyAccessDesc.value}. ${tmntData.earlyAccessSignIn.value}` : tmntData.earlyAccessDesc.value }
    </div>
  );
}
